import React, { useRef, useEffect } from 'react';
import { useUpdateEffect, useDeepCompareEffect } from 'ahooks';
import { registerEventGeometry } from '../events';
import Polyline from './Polyline';
import useProps from '../_util/useProps';

export default function(props) {
    const { data, property, label, position, style } = props;
    const featureRef = useRef();
    const { featureLayer } = useProps();

    useEffect(() => {
        let feature = new Polyline({
            geometry: data,
            style,
            properties: property,
            label,
            position,
        });

        // 注册事件
        registerEventGeometry(feature, props);

        featureLayer.entities.add(feature);

        featureRef.current = feature;

        return () => {
            featureLayer.entities.remove(feature);
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        featureRef.current.setPosition(position);
    }, [JSON.stringify(position)]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [JSON.stringify(property)]);

    useUpdateEffect(() => {
        featureRef.current.setLabel(label);
    }, [JSON.stringify(label)]);

    useDeepCompareEffect(() => {
        featureRef.current.setStyle(style);
    }, [style]);

    return <></>;
}
